import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { LeadsDataInitialState } from "./leadsData.state";
import { ILeadsDataState } from "./leadsData.types";
import {
    CLEAR_LEADS_DATA_STATE,
    FETCH_LEADS_DATA_FAILURE,
    FETCH_LEADS_DATA_PROGRESS,
    FETCH_LEADS_DATA_SUCCESS,
    FETCH_SINGLE_LEADS_DATA_FAILURE,
    FETCH_SINGLE_LEADS_DATA_PROGRESS,
    FETCH_SINGLE_LEADS_DATA_SUCCESS,
} from "./leadsData.action";

export const leadsDataReducer = (
    state: ILeadsDataState = LeadsDataInitialState,
    action: any
) => {
    switch (action.type) {
        case FETCH_LEADS_DATA_PROGRESS: {
            const newState = produce(state, (draftState: ILeadsDataState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.data = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_LEADS_DATA_SUCCESS: {
            const { data, totalRecords } = action.payload;
            const newState = produce(state, (draftState: ILeadsDataState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.data = data;
                draftState.list.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_LEADS_DATA_FAILURE: {
            const newState = produce(state, (draftState: ILeadsDataState) => {
                draftState.list.loading = LoadState.Failed;
                draftState.list.error = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_LEADS_DATA_PROGRESS: {
            const newState = produce(state, (draftState: ILeadsDataState) => {
                draftState.leadData.loading = LoadState.InProgress;
            });
            return newState;
        }
        case FETCH_SINGLE_LEADS_DATA_SUCCESS: {
            const newState = produce(state, (draftState: ILeadsDataState) => {
                draftState.leadData.loading = LoadState.Loaded;
                draftState.leadData.data = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_LEADS_DATA_FAILURE: {
            const newState = produce(state, (draftState: ILeadsDataState) => {
                draftState.leadData.loading = LoadState.Failed;
                draftState.leadData.error = action.payload;
            });
            return newState;
        }
        case CLEAR_LEADS_DATA_STATE: {
            return LeadsDataInitialState;
        }
        default: {
            return state;
        }
    }
};
